import { defineAsyncComponent } from 'vue'
export default {
  debug: defineAsyncComponent(() => import("/home/userapp/app/layouts/debug.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/userapp/app/layouts/default.vue").then(m => m.default || m))
}